import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PageHeader, PageSection, StartInkindCard, StickyHorizontal } from '@gik/ui';
import { MarketingNavSection } from '../../components/MarketingNav';
import CompetitorsComparisonTable from '../../components/CompetitorsComparisonTable';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import TestimonialsCarouselSection from '@gik/ui/gik/TestimonialsCarouselSection';
import { CreateClickedLocation } from '@gik/create/hooks/useCreateAnalytics';

export const CompetitorsPageBlockName = 'competitors-page';

export default function CompetitorsPage(): React.ReactElement {
  const bem = bemBlock(CompetitorsPageBlockName);
  const { t } = useTranslation();
  return (
    <div className={bem()}>
      <StickyHorizontal>
        <PageHeader decoration="foliage" variant="warm">
          <h1>{t(translationKeys.title)}</h1>
        </PageHeader>
        <PageSection className={bem('lead')} noPadBottom>
          <p className="gik-section-lead">{t(translationKeys.leadDescription)}</p>
        </PageSection>
      </StickyHorizontal>

      {/* TODO: move this to it's own component */}
      <PageSection contained={false} className="gik-competitors-comparison-section">
        <CompetitorsComparisonTable />
      </PageSection>

      <StickyHorizontal>
        <StartInkindCard trackingId={CreateClickedLocation.COMPETITORS_PAGE} />
        <TestimonialsCarouselSection />
        <MarketingNavSection variant="warm" />
      </StickyHorizontal>
    </div>
  );
}
